const getters = {
  token: state => state.user.token,
  name: state => state.user.name,
  userId: state => state.user.userId,
  avatar: state => state.user.avatar,
  third_account: state => state.user.third_account,
  bindWxModelShow: state => state.user.bindWxModelShow,
  wxHasBind: state => state.user.wxHasBind,
  sidebar: state => state.app.sidebar,
  permission_routers: state => state.permission.routers,
  // 新增的路由
  addRouters: (state) => {
    return state.permission.addRouters;
  },
  // 当前用户具有的权限
  permissions: (state) => {
    return state.user.permissions;
  },
  visitedViews: (state) => state.tagsView.visitedViews,
  buttons: (state) => state.user.buttons,
  complete: (state) => state.oss.complete,
};
export default getters;
